import { css } from 'styled-components'

const fontUrlCloudinary =
  'https://assets.nobiadigital.com/raw/upload/v1728370493/Fonts/WorkSans/'

const unoformFonts = css`
  @font-face {
    font-family: 'Work Sans';
    src: url(${fontUrlCloudinary}WorkSans-VariableFont_wght.ttf)
      format('truetype');
    font-weight: 200 500;
    font-display: swap;
  }
`
export default unoformFonts

